import { render, staticRenderFns } from "./View.vue?vue&type=template&id=49fadf6f"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=49fadf6f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fadf6f')) {
      api.createRecord('49fadf6f', component.options)
    } else {
      api.reload('49fadf6f', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=49fadf6f", function () {
      api.rerender('49fadf6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/notice/View.vue"
export default component.exports